const contentEnCA = `<div data-layout-type="text">
  <div class="EditableComponent__StyledEditableComponent-sc-ce164f1a-0 bSbwve copyItem">
    <div class="sc-fqkvVR hFmEmc"><span class="sc-cwHptR foJUNX">
      <p>I agree to receive electronic communications from Volkswagen Group Canada Inc., including its authorized dealers, affiliates (such as VW Credit Canada, Inc.), successors, assigns, and select third-party marketing partners. These communications may include invitations to exclusive owner events, news, promotions, special offers, and information about products, services, financing, and leasing options that may be of interest to me.</p>
      <br>
      <p>I understand that I may withdraw my consent at any time by contacting Volkswagen Group Canada Inc. at 777 Bayly Street West, Ajax, Ontario, L1S 7G7, or by visiting www.vw.ca and following the unsubscribe instructions.</p>
      <br>
      <p>I understand that my information will be handled for these purposes in accordance with Volkswagen Group Canada Inc.'s Privacy Policy.</p>
    </span></div>
  </div>
</div>`;

export default contentEnCA;
